__webpack_require__.p = "/tattoo-starter/";